import styles from './index.module.less';
import template from './index.art';
import { IOYFilterBarSaveListProps, IOYFilterBarSaveListState } from "./const";
import OY from '../../../../types/OY';
import { EEventType } from '../../../../enums/EEventType';
import { jeact } from '../../../../decorators/jeact';

@jeact()
export default class OYFilterBarSaveList extends OY<IOYFilterBarSaveListProps, IOYFilterBarSaveListState> {
  static displayName = 'OYFilterBarSaveList';

  static defaultProps: Partial<IOYFilterBarSaveListProps> = {
    activedSaveName: '',
    data: []
  };

  state: IOYFilterBarSaveListState = {
  }

  $node = {
    icon: $()
  }

  setScrollPosition() {
    const $actived = this.$class(styles.actived);
    if ($actived.length) {
      const { offsetTop } = $actived.eq(0).parent().parent().get(0);
      $actived.parent().parent().parent('ul').scrollTop(offsetTop - 45);
    }
  }

  render() {
    return template({ props: this.props, state: this.state, styles });
  }

  setNode() {
    this.$node = {
      icon: this.$el.find(`.${styles.icon}`)
    }
  }

  bindItemClick() {
    this.$el.find(`.${styles.item}`).click((event: Event) => {
      event.stopPropagation();
      const $elment = $(event.currentTarget!);
      const index = $elment.data('index');
      this.$class(styles.item).removeClass(styles.actived);
      $elment.addClass(styles.actived);
      this.eventEmitter.emit(EEventType.onClick, this.props.data[index], index)
    })
  }

  bindCloseClick() {
    this.$el.find(`.${styles.close}`).click((event: Event) => {
      event.stopPropagation();
      const $elment = $(event.currentTarget!);
      const index = $elment.data('index');
      this.eventEmitter.emit(EEventType.onRemove, this.props.data[index], index)
    })
  }
}



// WEBPACK FOOTER //
// ./src/components/OYFilterBar/components/OYFilterBarSaveList/index.ts